import { clientAuthorizedGet } from 'utils/fetchUtils';
import { API_ROUTES } from 'utils/constants';
import type { Customer } from 'types/customer';
import type { ContactGroup } from 'types/contactGroup';
import type { PaginatedResponse } from 'types/pagination';

export const CUSTOMERS_LIST_PAGE_SIZE = 10;

export type CustomersListQueryParams = {
  page: number;
  limit: number;
  search: string;
  includeVoided: boolean;
  includeGroupIds: string;
  excludeGroupIds: string;
};

export const customersListQueryKeys = {
  all: ['customers-list'] as const,
  groups: (companyId: string) =>
    [...customersListQueryKeys.all, 'groups', companyId] as const,
  page: (companyId: string, params: CustomersListQueryParams) =>
    [
      ...customersListQueryKeys.all,
      'page',
      companyId,
      params.page,
      params.limit,
      params.search,
      params.includeVoided,
      params.includeGroupIds,
      params.excludeGroupIds,
    ] as const,
};

function buildCustomersListRequestParams(
  params: CustomersListQueryParams,
): Record<string, string> {
  const query: Record<string, string> = {
    page: String(params.page),
    limit: String(params.limit),
    search: params.search,
    includeVoided: String(params.includeVoided),
  };
  if (params.includeGroupIds) {
    query.includeGroupIds = params.includeGroupIds;
  }
  if (params.excludeGroupIds) {
    query.excludeGroupIds = params.excludeGroupIds;
  }
  return query;
}

export async function fetchCustomersListPage(
  companyId: string,
  params: CustomersListQueryParams,
): Promise<PaginatedResponse<Customer>> {
  return clientAuthorizedGet<PaginatedResponse<Customer>>(
    API_ROUTES.CUSTOMERS,
    buildCustomersListRequestParams(params),
    companyId,
  );
}

export async function fetchCustomerGroupsList(
  companyId: string,
): Promise<ContactGroup[]> {
  return clientAuthorizedGet<ContactGroup[]>(
    API_ROUTES.CUSTOMER_GROUPS,
    {},
    companyId,
  );
}
